import { render } from "./ActivateAccount.vue?vue&type=template&id=360a652c"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"
script.render = render

export default script